import { REFUND_STATUS_OPTIONS } from '../constants/refundStatus'

const STATUS_DISPLAY_ALIASES = {
  pending: 'document_pending',
  // Compat: rejected quedó unificado en cancelled.
  rejected: 'cancelled'
}

export const getRefundStatusKey = (model = {}) => model.status

export const getNormalizedRefundStatusKey = (model = {}) => {
  const statusKey = getRefundStatusKey(model)
  return STATUS_DISPLAY_ALIASES[statusKey] || statusKey
}

export const getRefundStatusOption = (model = {}) => {
  const normalizedKey = getNormalizedRefundStatusKey(model)
  return REFUND_STATUS_OPTIONS[normalizedKey] || REFUND_STATUS_OPTIONS[model.status]
}

export const getRefundNcrDisplayValue = (model = {}) => {
  const normalizedKey = getNormalizedRefundStatusKey(model)
  const ncr = model.ncr_number

  if (ncr === 'N/A' || normalizedKey === 'cancelled') return 'N/A'
  if (ncr) return ncr
  return '-'
}
